import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";
import {UserAccountContext} from "../../../../contexts/userAccount";

function SettingsButton({to}) {
  return (
    <UserAccountContext.Consumer>
      {({user}) => {
        if (!user.permissions.edit.resources) {
          return null;
        }
        let disabled = !to;
        return (
          <Link to={to || "/"} disabled={disabled} className="settingsLink">
            <IconButton disabled={disabled} className="placebarButton placebarSettingsButton">
              <span className="border" />
              <FontAwesomeIcon icon={faCog} className="placebarButtonIcon" />
            </IconButton>
          </Link>
        );
      }}
    </UserAccountContext.Consumer>
  );
}

SettingsButton.propTypes = {
  to: PropTypes.string
};

export default SettingsButton;



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/SettingsButton.jsx